import React, { useState } from 'react';
import { Grid, InputAdornment } from '@mui/material';
import { Place, Search } from '@mui/icons-material';
import { Colors, Text, IconButton, OutlinedTextInput } from 'library';
import { StaffFilterOptions, defaultFilters } from './StaffFilter';

export default function ZipSearch({
    zipCode,
    updateZipCode,
    search,
}: {
    zipCode: string;
    updateZipCode: (e: React.ChangeEvent<HTMLInputElement>) => void;
    search: (filters: StaffFilterOptions) => void;
}) {
    const [showHelperText, setShowHelperText] = useState(false);

    function onSearch() {
        if (zipCode.length < 5) {
            setShowHelperText(true);
        } else {
            setShowHelperText(false);
            search(defaultFilters);
        }
    }

    function enterPressHandler(e: React.KeyboardEvent<HTMLInputElement>) {
        if (e.key === 'Enter') {
            onSearch();
        }
    }

    return (
        <Grid>
            <Text bold textStyle={{ marginBottom: 10, marginLeft: 3 }}>
                Zip Code
            </Text>
            <OutlinedTextInput
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <Place style={{ color: Colors.darkNavy }} />
                        </InputAdornment>
                    ),
                    endAdornment: (
                        <InputAdornment position="end">
                            <IconButton
                                onClick={onSearch}
                                color={Colors.white}
                                backgroundColor={Colors.darkNavy}
                                icon={Search}
                            />
                        </InputAdornment>
                    ),
                }}
                style={{ width: '100%', backgroundColor: 'white', borderRadius: 15 }}
                placeholder="Zip Code"
                value={zipCode}
                onChange={updateZipCode}
                onKeyUp={enterPressHandler}
                helperText={showHelperText ? 'Please enter a valid zip code' : null}
            />
        </Grid>
    );
}
